import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { DatePicker, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class DatePickerDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				default: "",
                placeholder: "",
                disabled: "",
                preset: "05 Sep 1998",
                presetAndRequired: "24 Apr 2010",
                required: ""
			}
		};
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="DatePicker">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={4}>
							<Label htmlFor="default">Default</Label>
							<DatePicker name="default" />
						</Col>
						<Col md={4}>
							<Label htmlFor="placeholder">Placeholder</Label>
							<DatePicker name="placeholder" placeholder={"Input a date"} />
						</Col>
						<Col md={4}>
							<Label htmlFor="disabled">Disabled</Label>
							<DatePicker name="disabled" disabled />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label htmlFor="preset">Preset</Label>
							<DatePicker name="preset" />
						</Col>
						<Col md={4}>
							<Label htmlFor="required" required>Required</Label>
							<DatePicker name="required" required />
						</Col>
						<Col md={4}>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label htmlFor="preset" required>Preset & Required</Label>
							<DatePicker name="presetAndRequired" required />
						</Col>
						<Col md={4}>
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default DatePickerDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DatePickers/DatePickerDemo.js